import { BrowserRouter, Route, Routes } from "react-router-dom";
import Accueil from "../pages/Accueil";
import Activite from "../pages/Activite";
import ActiviteBebe from "../pages/ActiviteBebe";
import Activites from "../pages/Activites";
import ActivitesCategorie from "../pages/ActivitesCategorie";
import ConditionsGenerales from "../pages/ConditionsGenerales";
import Contact from "../pages/Contact";
import DroitDeGarantie from "../pages/DroitDeGarantie";
import Erreur from "../pages/Erreur";
import Evenements from "../pages/Evenements";
import Inscription from "../pages/Inscription";
import MentionLegal from "../pages/MentionsLegal";
import Planning from "../pages/Planning";
import Tarifs from "../pages/Tarifs";

export default function Router() {
    return (
        <BrowserRouter>
            <Routes>
                {/* Accueil */}
                <Route index element={<Accueil />} />

                {/* Inscription */}
                <Route path="inscription" element={<Inscription />} />

                {/* Activités */}
                <Route path="activites">
                    <Route index element={<Activites />} /> {/* /activites */}
                    <Route path="bebes-nageurs" element={<ActiviteBebe />} /> {/* /activites/bebes-nageurs */}
                    <Route path=":categorie" element={<ActivitesCategorie />} /> {/* /activites/enfants */}
                    <Route path=":categorie/:slug" element={<Activite />} /> {/* /activites/aquagym */}
                </Route>

                {/* Planning */}
                <Route path="planning" element={<Planning />} />

                {/* Tarifs */}
                <Route path="tarifs" element={<Tarifs />} />

                {/* Événements */}
                <Route path="anniversaire" element={<Evenements />} />

                {/* Contact */}
                <Route path="contact" element={<Contact />} />

                {/* Mentions légales */}
                <Route path="mentions-legales" element={<MentionLegal />} />

                {/* Droit De Garantie */}
                <Route path="droit-de-garantie" element={<DroitDeGarantie />} />

                {/* Conditions Générales d’Abonnement */}
                <Route path="conditions-generales" element={<ConditionsGenerales />} />

                {/* 404 */}
                <Route path="*" element={<Erreur />} />
            </Routes>
        </BrowserRouter>
    );
}
